import { ACTION_CHECK_INITIALIZE_LIST } from "../actions/check-initialize";
import { ACTION_CHECK_ITEM_LIST } from "../actions/check-items";
import { ACTION_CHECK_LIST } from "../actions/checks";

let initialReducer = {
    checkInitialize: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
            initialized: '',
        }
    },
    check: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
        }
    },
    checkItems: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
            checkDate: '',
        }
    },
}

let CheckReducers = (state = initialReducer, action) => {
    switch (action.type) {
        case ACTION_CHECK_INITIALIZE_LIST.type:
            return {
                ...state,
                checkInitialize: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                        initialized: action.payload.initialized,
                    },
                }
            };
        case ACTION_CHECK_LIST.type:
            return {
                ...state,
                check: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                    },
                }
            };
        case ACTION_CHECK_ITEM_LIST.type:
            return {
                ...state,
                checkItems: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                        checkDate: action.payload.checkDate,
                    },
                }
            };
        default:
            return state;
    }
}

export default CheckReducers